import { Graph, LinkSet } from '../types';

/**
 * Get a modified dependencies from an original dependency graph and
 * sets of added and removed links.
 */
function getModifiedDependencies(
  originalDependencies: Graph,
  addedLinks: LinkSet,
  removedLinks: LinkSet,
): Graph {
  const dependencies = { ...originalDependencies };

  addedLinks.forEach((link) => {
    const { parent, child: childToAdd } = JSON.parse(link);
    dependencies[parent] = [...(dependencies[parent] || []), childToAdd];
  });
  removedLinks.forEach((link) => {
    const { parent, child: childToRemove } = JSON.parse(link);
    dependencies[parent] = (dependencies[parent] || []).filter((child) => child !== childToRemove);
  });

  return dependencies;
}

export default getModifiedDependencies;
